import GlobalSearch from './container/index';

export default GlobalSearch;




// WEBPACK FOOTER //
// ./src/views/GlobalSearch/index.js